"use client";

import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "groupHomeNoteGuideModalHidden";

export function useGroupHomeNoteGuideModal() {
  const [shouldHide, setShouldHide] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);

      // 永続的に非表示設定がある場合（一度表示したら二度と表示しない）
      if (stored === "true") {
        setShouldHide(true);
      } else {
        setShouldHide(false);
      }
    } catch (error) {
      console.warn("Failed to read from localStorage:", error);
      setShouldHide(false);
    } finally {
      setIsLoaded(true);
    }
  }, []);

  const setHideModal = useCallback((hide: boolean) => {
    try {
      if (hide) {
        // 永続的に非表示（一度表示したら今後表示しない）
        localStorage.setItem(STORAGE_KEY, "true");
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
      setShouldHide(hide);
    } catch (error) {
      console.warn("Failed to write to localStorage:", error);
    }
  }, []);

  const shouldShowModal = useCallback(() => {
    if (!isLoaded) return false; // ローカルストレージ読み込み前は非表示
    if (shouldHide) return false; // 非表示設定がある場合は非表示

    // 初回は必ず表示
    return true;
  }, [shouldHide, isLoaded]);

  return {
    shouldShowModal,
    setHideModal,
    isLoaded,
  };
}
